import { useContext } from "react";
//#region types
import { ReApproveContextState } from "models/propTypes/wintSalaryPropTypes";
//#endregion
//#region components
import { ReApproveContext } from "./index";
//#endregion

export const useReApproveContext = (): ReApproveContextState => {
  const context = useContext(ReApproveContext);
  if (!context) {
    throw new Error("useReApproveContext must be used within a ReApproveProvider");
  }
  return context;
};
